import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'

import Form from '../../../../../../../components/Form'
import Field from '../../../../../../../components/Form/Field'

import { usePurifiedFormik } from '../../../../../../../hooks/formHooks/usePurifiedFormik'

import {
  createFacebookPageAccessRequest,
  clearCreateFacebookPageAccessRequest
} from '../../../../../../../modules/actions/socialAccounts'
import { selfAccountSelector } from '../../../../../../../modules/selectors/selfAccounts'
import {
  createFacebookPageAccessRequestErrorSelector,
  createFacebookPageAccessRequestIsLoadingSelector,
  createFacebookPageAccessRequestWasCreatedSelector
} from '../../../../../../../modules/selectors/socialAccounts'
import { selectedFacebookAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { FACEBOOK_PAGE_ID, initialValues, validationSchema } from './fields'
import { REQUEST_FACEBOOK_PAGE_ACCESS } from '../../../../../../../constants/forms'

import useDrawerFormClasses from '../../../../../../../styles/common/drawerForms'

const RequestPageAccessForm = () => {
  const drawerFormClasses = useDrawerFormClasses()

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const selfAccount = useSelector(selfAccountSelector)
  const pageAccessRequestWasCreated = useSelector(createFacebookPageAccessRequestWasCreatedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)

  const { facebook_bm_id: facebookBusinessManagerId } = selfAccount

  const onSubmit = useCallback(
    values => {
      dispatch(
        createFacebookPageAccessRequest({
          ...values,
          account: selectedAdAccountId,
          facebook_bm_id: facebookBusinessManagerId
        })
      )
    },
    [dispatch, selectedAdAccountId, facebookBusinessManagerId]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const clearRequestPageAccessHandler = useCallback(() => {
    dispatch(clearCreateFacebookPageAccessRequest())
  }, [dispatch])

  return (
    <Form
      formName={REQUEST_FACEBOOK_PAGE_ACCESS}
      formik={purifiedFormik}
      successSubmit={pageAccessRequestWasCreated}
      errorSelector={createFacebookPageAccessRequestErrorSelector}
      isLoadingSelector={createFacebookPageAccessRequestIsLoadingSelector}
      clearHandler={clearRequestPageAccessHandler}
      submitText="Request Access"
    >
      <section className={drawerFormClasses.section}>
        <h3 className={drawerFormClasses.sectionTitle}>{t('Facebook page ID')}</h3>
        <p>{t('Enter the ID of the Facebook page to request access to')}</p>
        <Field placeholder="Facebook page ID" formik={formik} name={FACEBOOK_PAGE_ID} />
      </section>
    </Form>
  )
}

export default RequestPageAccessForm
